import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getStatus, logout, type ConnectStatus } from './lib/api';

export function App() {
  const [status, setStatus] = useState<ConnectStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getStatus()
      .then((s) => {
        if (cancelled) return;
        setStatus(s);
        if (!s.user && loc.pathname !== '/login') nav('/login', { replace: true });
      })
      .catch(() => {
        if (cancelled) return;
        setStatus(null);
        if (loc.pathname !== '/login') nav('/login', { replace: true });
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [loc.pathname, nav]);

  async function onSignOut() {
    try {
      await logout();
    } finally {
      setStatus(null);
      nav('/login', { replace: true });
    }
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">mailmeback</div>
        <nav>
          {status?.user ? (
            <>
              <NavLink
                to="/connect"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Connections
              </NavLink>
              <NavLink
                to="/backfill"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Backfill
              </NavLink>
              <span className="email">{status.user.email}</span>
              <button type="button" className="signout" onClick={onSignOut}>
                Sign out
              </button>
            </>
          ) : null}
        </nav>
      </header>
      <main>
        {loading ? <div className="loading">Loading the mailroom…</div> : <Outlet context={status} />}
      </main>
      <footer className="footer">
        <div className="footer-row">
          <span>
            © 2026{' '}
            <a href="https://github.com/netmet12" target="_blank" rel="noreferrer">
              Nate Moshel
            </a>
          </span>
          <span className="footer-sep">·</span>
          <span>
            In collaboration with{' '}
            <a href="https://optidge.com/" target="_blank" rel="noreferrer">
              Optidge
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
